import { render } from "./StatusTemplate.vue?vue&type=template&id=97d81b8c"
import script from "./StatusTemplate.vue?vue&type=script&lang=js"
export * from "./StatusTemplate.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__